import type { IconNode } from '../types';

/**
 * @name onion
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIyIiAvPgogIDxjaXJjbGUgY3g9IjEyIiBjeT0iMTIiIHI9IjYiIC8+CiAgPHBhdGggZD0iTTIuOCA4LjFhMTAgMTAgMCAxIDAgNS4zLTUuM0M1IDQgMyAyIDMgMkwyIDNzMiAyIC44IDUuMSIgLz4KICA8cGF0aCBkPSJNMTggMjB2MiIgLz4KICA8cGF0aCBkPSJtMjEgMjEtMS45LTEuOSIgLz4KICA8cGF0aCBkPSJNMjIgMThoLTIiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/onion
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const onion: IconNode = [
  ['circle', { cx: '12', cy: '12', r: '2', key: '1c9p78' }],
  ['circle', { cx: '12', cy: '12', r: '6', key: '1vlfrh' }],
  ['path', { d: 'M2.8 8.1a10 10 0 1 0 5.3-5.3C5 4 3 2 3 2L2 3s2 2 .8 5.1', key: '1sqdid' }],
  ['path', { d: 'M18 20v2', key: '10uadw' }],
  ['path', { d: 'm21 21-1.9-1.9', key: '1g2n9r' }],
  ['path', { d: 'M22 18h-2', key: '1qhgzi' }],
];

export default onion;
